import { Pipe, PipeTransform } from '@angular/core';
import { InvoicePaymentMethod } from '~core/models/invoice.models';

@Pipe({
  name: 'invoicePaymentMethod',
  pure: true,
  standalone: true
})
export class InvoicePaymentMethodPipe implements PipeTransform {
  private readonly _methodMap: Record<InvoicePaymentMethod, string> = {
    [InvoicePaymentMethod.bankCard]: 'Carte bancaire',
    [InvoicePaymentMethod.check]: 'Chèque',
    [InvoicePaymentMethod.cash]: 'Espèces',
    [InvoicePaymentMethod.mobileMoney]: 'Mobile Money',
    [InvoicePaymentMethod.transfer]: 'Virement',
    [InvoicePaymentMethod.eventually]: 'Paiement à terme'
  };

  transform(
    methods: InvoicePaymentMethod | InvoicePaymentMethod[] | undefined
  ): string {
    if (!methods || (Array.isArray(methods) && !methods.length)) {
      return 'Inconnue';
    }

    if (Array.isArray(methods)) {
      return methods.map(method => this._methodMap[method] || method).join(', ');
    }

    return this._methodMap[methods] || methods;
  }
}
